module.exports = __webpack_public_path__ + "media/img/decorations/history-year-before-desk-b871ed1fd11ceab090e7630cf4b30275.svg";